"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M11.7.14a.5.5 0 00-.7 0L.9 10a.5.5 0 00-.14.28L0 15.43a.5.5 0 00.59.56l5.14-1a.5.5 0 00.26-.14l9.85-9.92a.5.5 0 000-.7L11.71.13zM1.1 14.87l.62-4.28 7.13-6.95 3.48 3.42-6.93 6.97-4.3.84zm11.94-8.52l1.75-1.77-3.43-3.38-1.8 1.74 3.48 3.4z"
}));

exports["default"] = _default;